import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Scrollbars from "react-custom-scrollbars";
import ModuleCategory from '../../../components/module_category';
import Button from '../../../atoms/button';
import { createConfigurationWithModule, setHeadQuestionsWithAnswers, setBaseOptions, setActiveStep, cancelConfiguration, setConfigurationHeadModule, replaceModule, preSaveConfiguration } from '../../../features/configuration-management/ducks';
import { stepsConfig, possible_starter_selections, configurationStatuses, pacdrive_ranges, configurationModuleType, surveyTypes, surveyEventTypes, eventForceShowingSurvey } from '../../../constants';
import { getStepperLabels } from '../../../utils/linear-stepper';
import { getQuestions } from '../../question-management/ducks';
import { getHeadModules } from '../../get-modules/ducks';
import I10n from '../../../features/i10n';
import LoadingSpinner from '../../../atoms/loading';
import { getAppLocale } from '../../../utils/app-locale';
import ProductInformationCache from '../../../persistence/description-cache';
import Configuration from '../../../models/Configuration';
import Device from '../../../models/Device';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { removeHandleDefaultSearchParameters } from './ducks';
import { appConfiguration } from '../../../utils/app-starter';
import MsxIcons from '../../msx-icons';
import { openModal, closeModal } from '../../modals/ducks';
import ApplicationFullHeader from '../../../components/application_full_header';
import { getSurvey } from '../../survey-management/ducks';
import Survey from '../../../components/survey';
import { setCBRSelectedItems } from '../../call-by-range/ducks';
import { logDeleteCBRFilterEvent, logSurveyOpenEvent, logSurveySubmitEvent } from '../../../utils/analytics-logger';
import { updateShowButtonAnimations } from '../start_configuration_screen/ducks';
import { buildMySchneiderUrlWithCBR } from '../../../utils/url-builder';
import { showNotificationWithButton } from '../../notification/ducks';
import Notification from '../../notification';
import FilterHead from '../../../components/question_list_filter_header';
import FilterContent from '../../../components/question_list_filter_answer';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh);
  overflow-x: hidden;
  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0;left: 0;right:0;bottom: 0;
    overflow: auto;
    background-color: white;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0;left: 0;right:0;bottom: 0;
    overflow: auto;
    background-color: white;
    padding: 0px;
  `}
`;

const FullScreenScrollbarWrapper = styled.div`
  height: 100%;
`;

const SearchHeader = styled.div`
flex: 1 1 0px;
`;

const DeviceSectionWrapper = styled.div`
display: flex;
flex: 1 1 0px;
flex-direction: row;
padding-top: 16px;
`;

const DeviceSection = styled.section`
${props => props.isFilterOpen && '  margin-left: 15px'};
  display: flex;
  flex-direction: column;
  flex: 2 1 0px;
  @media (max-width: 800px) {
    margin-left: 0;
  }
`;

const MobileQuestionManagement = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const LoadingMask = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: grey;
  z-index: 1;
  opacity: 0.2;
`;

const SearchReferenceInput = styled.input`
  border-radius: 20px;
  width: 100%;
  max-width: none;
  padding: 5px;
  height: 30px;
  border: 1px solid #E6E6E6;
  color: #A4A4A4;
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ::placeholder {
    color: #9FA0A4;
  }
`;

const PageContent = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 0px 24px 0px 16px;
  ${props => props.fullScreenEnabled && `
    height: 100%;
  `}
`;

const DeviceSectionHeadText = styled.h3`
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0 10px;
  font-size: 22px;
  line-height: 30px;
  font-weight: 400;
  color: #626469;
`;

const DeviceSectionContent = styled.div`
  position: relative;
  flex: 1 1 400px;
  display: flex;
  flex-direction: column;
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  border-top: 2px solid #EDEDED;
  background-color: white;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 800px) {
    min-height: auto;
    display: none;
  }
  ${props => props.fullScreenEnabled && `
    min-height: auto;
  `}
`;

const FillSpace = styled.div`
  height: 45px;
  min-height: 45px;
  width: 10px;
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
`;

const SearchBarIcon = styled.div`
    position: relative;
    left: 35px;
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 16px;
  @media (max-width: 800px) {
    padding-top: 0;
  }
`;

const SearchBarTestWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const FilterContentWrapper = styled.div`
  width: ${props => props.isFilterOpen ? '350px' : '0'};
  display: ${props => props.isFilterOpen ? 'flex' : 'none'};
  margin-top:${props => props.isFilterOpen ? '-45px' : '0'};
  position: relative;

  @media (max-width: 800px) {
    flex-grow: 1;
    background-color:white;
    position: absolute;
    top: 48px;
    bottom: 0px;
    z-index: 1000;
    width: 100%;
    right: 0;
    left: 0;
  }
`;

const FilterHeadWrapper = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  ${props => props.isHidden ? 'visibility: hidden;' : ''}

   @media (max-width: 800px) {
  }
`;

const SearchBarWrapper = styled.div`
  flex-grow: 1;
  margin-left: -5px;
`;

const ContentWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-top: 2px solid #cccc;
  padding: 10px 15px 0 15px;
`;

const SearchBarTestWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const FilterHeadWrapperMobile = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  width: 100%;
  ${props => props.isHidden ? 'visibility: hidden;' : ''}
`;

const SearchBarWrapperMobile = styled.div`
  flex-grow: 1;
  margin-left: -5px;
  width: 100%;
  margin-top: 10px;
`;

const SearchBarMobile = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 0px;
  margin-left: -36px;
  padding-left: 15px;
`;

const Test = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;


class HeadDeviceSelectorScreen extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    try {
      this._search = window.parent.location.search;
    } catch (error) {
      this._search = window.location.search;
    }

    const search = props.shouldHandleDefaultSearchParameters ? (appConfiguration.plcSearch || '') : '';

    this.state = {
      search,
      ranges: [],
      remainingOptions: {},
      sharedOptions: {},
      headDeviceSelected: null,
      mobileFilterOpened: false,
      isDesktop: window.innerWidth > 800,
      shouldHandleDefaultSearchParameters: props.shouldHandleDefaultSearchParameters,
      isFilterOpen : window.innerWidth > 800,
    }
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  componentDidMount() {
    this.props.getSurvey().then(() => {
      if (this.props.showButtonAnimations?.survey) {
        window.dispatchEvent(new Event(eventForceShowingSurvey));
      }
    }).finally(() => {
      this.props.updateShowButtonAnimations();
    });

    window.addEventListener("resize", this.updateIsDesktop);
    this._isMounted = true;
    this.props.getAggregatedQuestions(this.props.configuration.starterType).then(() => {

      const shouldHandleDefaultSearchParameters = this.props.shouldHandleDefaultSearchParameters;

      this.getHeadModules(this.props.configuration.headQuestionsWithAnswers, true).then((res) => {

        const selectedReferences = this.props.callByRangeReducer?.selectedItems?.references ? Object.keys(this.props.callByRangeReducer.selectedItems.references) : [];
        if ((shouldHandleDefaultSearchParameters && appConfiguration.plcSearch) || selectedReferences.length === 1) {
          if (res) {
            const allReferences = [];
            for (let range of res) {
              allReferences.push(...range.references);
            }
            let plc;
            if (shouldHandleDefaultSearchParameters && appConfiguration.plcSearch) {
              plc = allReferences.find(ref => ref.id === appConfiguration.plcSearch);
            } else if (selectedReferences.length === 1) {
              plc = allReferences.find(ref => ref.id === selectedReferences[0]);
            }

            if (plc && this._isMounted) {
              this.props.createConfigurationWithModule(plc, null).then((data) => {
                const headModuleKits = this.props.pacdriveKits.kits[data?.configuration?.headModule?.id] || {};

                if (pacdrive_ranges.includes(data?.configuration?.rangeInfo?.rangeName)
                  && Object.keys(headModuleKits).length > 0) {
                  this.handlePacdriveModal(data);
                }
              }).catch((error) => {
              });
            }
          }

        } else {
          // Check if the old configuration head module is still in the list to selection it.
          const oldHeadModule = [].concat.apply([], res.map(range => range.references)).filter(ref => ref.id === this.props.configuration.headModule?.id).shift();
          if (oldHeadModule) {
            this.updateStateIfMounted({ headDeviceSelected: oldHeadModule });
          }
        }
      });

      this.props.removeHandleDefaultSearchParameters();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsDesktop);
    this._isMounted = false;
    this.props.closeModal();
  }

  get baseI10nKey() {
    const starterType = Object.values(possible_starter_selections).includes(this.props.configuration.starterType) ?
      this.props.configuration.starterType : '???';
    return `screen.head_device_selector_screen.${starterType}`;
  }

  get eligibleRanges() {
    const ranges = this.state.ranges || [];
    const search = (this.state.search || '').toLowerCase();
    const eligibleRanges = [];
    if (search.length) {
      const keywords = search.split(' ').filter(k => !!(k || '').length);
      for (let { label, translationKey, references, ...other } of ranges) {
        const filteredRefs = references.filter(ref => {
          const device = new Device(ref);

          const deviceFields = [
            device.id,
            I10n.getOrDefault(`modules.${device.id}.description`, device.description, 'data'),
            ProductInformationCache.getDescription(device.id),
            I10n.getOrDefault(`category.${translationKey}.name`, label, 'data') // Filter also by category name
          ].map(f => (f || '').toLowerCase());
          return !!deviceFields.filter(field => {
            return keywords.filter(keyword => field.includes(keyword)).length === keywords.length;
          }).length;
        });
        if (filteredRefs.length) {
          eligibleRanges.push({
            ...other,
            label,
            translationKey,
            'references': filteredRefs,
          });
        }
      }
    } else {
      ranges.forEach(range => eligibleRanges.push(range));
    }
    return eligibleRanges;
  }

  get numberQuestionsAnswered() {
    return Object.keys(this.props.configuration?.headQuestionsWithAnswers).length;
  }

  get haveQuestionsAnswered() {
    return !!Object.keys(this.props.configuration?.headQuestionsWithAnswers).length;
  }

  buildRanges(ranges) {
    const allReferences = [];
    for (let range of ranges) {
      allReferences.push(...range.references);
    }
    this.updateStateIfMounted({ ranges: ranges });
    this.removeHeadModuleSelectionIfNotInResult(allReferences);
  }

  updateStateIfMounted(objectToAffect) {
    if (this._isMounted) {
      this.setState(objectToAffect);
    }
  }

  removeHeadModuleSelectionIfNotInResult(references) {
    const referencesId = references.map((e) => { return e.id; });
    if (this._isMounted && this.state.headDeviceSelected) {
      if (referencesId.indexOf(this.state.headDeviceSelected.id) === -1) {
        this.updateStateIfMounted({ headDeviceSelected: null });
      }
    }
  }

  getHeadModules(questionsWithAnswers, initialCall = false) {
    return this.props.getHeadModules(this.props.configuration.starterType, this.buildCriteriaPayload(questionsWithAnswers))
      .then((response) => {
        this.buildRanges(response.ranges);
        this.updateStateIfMounted({
          remainingOptions: response.remainingCriteria,
          sharedOptions: response.sharedCriteria
        });
        if (initialCall && Object.keys(questionsWithAnswers).length === 0) {
          this.props.setBaseOptions(response.remainingCriteria);
        }

        return response.ranges;
      });
  }

  getQuestionMap() {
    const questionMap = {};
    for (const questionCategory of this.props.questions.aggregatedQuestions) {
      for (const question of questionCategory.questions) {
        questionMap[question.questionKey] = question;
      }
    }
    return questionMap;
  }

  buildCriteriaPayload(questionsWithAnswers) {
    const questionMap = this.getQuestionMap();
    const payload = {};
    for (const [key, answer] of Object.entries(questionsWithAnswers)) {
      try {
        payload[questionMap[key].criteria] = answer;
      } catch (error) {
        // Filter non existing criteria
      }
    }
    return payload;
  }

  onAnswerChanged = (questionsWithAnswers) => {
    this.props.setHeadQuestionsWithAnswers(questionsWithAnswers);
    this.getHeadModules(questionsWithAnswers);
  }

  resetQuestionAnswers() {
    this.onAnswerChanged({});
  }

  handleSearchChange = (event) => {
    this.setState({ search: event.currentTarget.value });
  }

  renderRanges = () => {
    const appLocale = getAppLocale();
    const ranges = this.state.ranges || [];
    const eligibleRanges = this.eligibleRanges || [];
    // Do not show the indications if the modules are loading.
    if (!this.props.headModules.isLoading && !this.props.questions.isLoading) {
      if (!ranges.length && !this.haveQuestionsAnswered) {
        return <p>{I10n.getAndReplace(`${this.baseI10nKey}.suggest.empty`, appLocale)}</p>;
      }
      if (!eligibleRanges.length) {
        return <p>{I10n.get(`${this.baseI10nKey}.suggest.no-match`)}</p>;
      }
    }
    return eligibleRanges.map(range => {
      return (
        <ModuleCategory
          id={range.translationKey}
          key={range.translationKey}
          title={I10n.getOrDefault(`category.${range.translationKey}.name`, range.label, 'data')}
          label={range.label}
          description={I10n.getOrDefault(`category.${range.translationKey}.description`, range.description, 'data')}
          detailedDescription={range.detailedDescription}
          image={range.imageURL || 'https://via.placeholder.com/200'}
          references={range.references}
          setSelectedDevice={(device) => {
            if (device !== null) {
              this.setState({ headDeviceSelected: device });
            } else {
              this.setState({ headDeviceSelected: null });
            }
          }}
          selectedDevice={this.state.headDeviceSelected}
          withCount={true}
          onOpenStateChange={(isOpen, ref) => {
            this.forceUpdate();
            if (isOpen) {
              setTimeout(() => {
                this.scrollComponent.view.scrollTop = ref.current.offsetTop;
              }, 0);
            }
          }}
          forceOpen={!this.props.headModules.isLoading && (this.haveQuestionsAnswered || eligibleRanges.length === 1)}
          boundingElementTooltip={this.deviceSectionElement}
        />
      );
    });
  }
  get hasSelection() {
    return this.state.headDeviceSelected !== null;
  }

  handlePacdriveModal = (data) => {
    this.props.openModal({
      modalType: 'pacdrive-adjust',
      modalProps: {
        onCancel: () => { this.props.closeModal(); },
        onSubmit: (newReferenceID) => {
          this.props.replaceModule(data.configuration, 0, configurationModuleType.head_module, newReferenceID).then(() => {
          }).catch(() => { });
          this.props.closeModal();
        },
        headModule: data.configuration.headModule,
      }
    });
  }

  createConfigurationWithModule = () => {
    this.props.createConfigurationWithModule(this.state.headDeviceSelected, this.props.configuration.headQuestionsWithAnswers).then((data) => {
      const headModuleKits = this.props.pacdriveKits.kits[data?.configuration?.headModule?.id] || {};
      if (pacdrive_ranges.includes(data?.configuration?.rangeInfo?.rangeName)
        && Object.keys(headModuleKits).length > 0) {
        this.handlePacdriveModal(data);
      }

    }).catch(() => { });
  }

  setConfigurationHeadModule = () => {
    this.props.setConfigurationHeadModule(this.state.headDeviceSelected, this.props.configuration.headQuestionsWithAnswers).then((data) => {
      const headModuleKits = this.props.pacdriveKits.kits[data?.configuration?.headModule?.id] || {};
      if (pacdrive_ranges.includes(data?.configuration?.rangeInfo?.rangeName)
        && Object.keys(headModuleKits).length > 0) {
        this.handlePacdriveModal(data);
      }
    });
  }

  renderNavigationButtons = () => {
    return <>
      {!appConfiguration.disableCallByRangeBackToStart && <CancelWrapper>
        <Button
          id='head-device-selector-screen-back-button'
          disabled={this.props.configurationSaver.isSaving}
          onClick={() => {
            const isOldConfigurationSaved = (configurationStatuses.finished === this.props.configuration.status) || (this.props.configuration.id == null);
            this.confirmationBeforeCancel(!isOldConfigurationSaved, this.props.cancel);
          }}
        >{I10n.get('app.action.back')}</Button>
      </CancelWrapper>}
      {this.props.configurationSaver.isSaving ? <LoadingSpinner width="25px" height="25px"></LoadingSpinner> : <Button
        importance="emphasized"
        id='head-device-selector-screen-continue-button'
        primary
        disabled={!this.hasSelection
          || this.props.configurationSaver.isSaving
          || this.props.headModules.isLoading}
        onClick={event => {
          if (this.props.configuration.headModule !== null) {
            if (this.props.configuration.headModule?.id === this.state.headDeviceSelected.id) {
              this.props.continue();
            } else {
              this.props.openModal({
                modalType: 'confirmation',
                modalProps: {
                  onCancel: () => { this.props.closeModal(); },
                  onSubmit: () => {
                    this.props.closeModal();
                    if (configurationStatuses.finished === this.props.configuration.status) {
                      this.createConfigurationWithModule();
                    } else {
                      this.setConfigurationHeadModule();
                    }
                  },
                  title: I10n.get('screen.config_editor.modal_new_configuration.title'),
                  text: I10n.get('screen.config_editor.modal_new_configuration.body'),
                  cancelText: I10n.get('app.action.cancel'),
                  submitText: I10n.get('app.action.continue'),
                }
              });
            }
          } else {
            // ID of the configuration can be null if the user went directly to the step due to parameter in URL
            if (this.props.configuration.id == null) {
              this.createConfigurationWithModule();
            } else {
              this.setConfigurationHeadModule();
            }
          }
        }}
      >{I10n.get('app.action.continue')}</Button>}

    </>;
  }

  renderNavigationButtonSection = () => {
    const buttons = this.renderNavigationButtons();
    return (<>
      {(!this.state.mobileFilterOpened) &&
        <>
          <FullScreenNavigationButtonSection>
            {buttons}
          </FullScreenNavigationButtonSection>
          <HiddenNavigationButtonSection>
            {buttons}
          </HiddenNavigationButtonSection>
        </>
    }
    </>);
  }


  confirmationBeforeCancel = (shouldShowConfirmation, cancelCallback) => {
    if (shouldShowConfirmation) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            cancelCallback();
            this.props.closeModal();
            if (this.props.configuration.id) {
              this.props.cancelConfiguration(this.props.configuration.id);
            } else {
              cancelCallback();
            }

          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  getStepperActions = () => {
    const config = new Configuration(this.props.configuration);
    const isConfigurationSaved = (configurationStatuses.finished === this.props.configuration.status);
    const configurationHasHeadModule = (this.props.configuration.headModule !== null);

    return [
      { action: () => { this.confirmationBeforeCancel(!isConfigurationSaved && this.props.configuration.id != null, this.props.cancel) }, active: true, done: true, hidden: appConfiguration.disableCallByRangeBackToStart },
      { action: () => { }, active: true, done: configurationHasHeadModule },
      { action: () => {
        if (isConfigurationSaved) {
          this.props.continue()
        } else {
          this.props.preSaveConfiguration(this.props.configuration, stepsConfig.configuration_editor_screen);
        }
       }, active: configurationHasHeadModule, done: isConfigurationSaved || (config.canUsePowerSupply() && config.hasPowerSupplies()) || config.hasDeviceAccessorized() || config.hasSoftwareLicenseSelection()},
      { action: () => {
        if (isConfigurationSaved) {
          this.props.setActiveStep(stepsConfig.power_supply);
        } else {
          this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply)
        }
       }, active: configurationHasHeadModule && config.canUsePowerSupply(), hidden: config.starterType === possible_starter_selections.PAC,
      done: config.hasPowerSupplies(),
      skipped: isConfigurationSaved && config.canUsePowerSupply() && !config.hasPowerSupplies() // Don't display the skipped status on in progress configurations

      },
      { action: () => {
        if (isConfigurationSaved) {
          this.props.setActiveStep(stepsConfig.accessorize);
        } else {
          this.props.preSaveConfiguration(this.props.configuration, stepsConfig.accessorize)
        }
      }, active: (configurationHasHeadModule && config.fullConfigurationHasDevicesToAccessorize()),
      done: isConfigurationSaved, skipped: isConfigurationSaved && !config.hasDeviceAccessorized() && !config.hasSoftwareLicenseSelection() },
      { action: () => {
        if (configurationStatuses.finished === this.props.configuration.status) {
          this.props.setActiveStep(stepsConfig.save_screen);
        } else {
          if (config.canUsePowerSupply() && !config.hasPowerSupplies()) {
            this.props.openModal({
              modalType: 'confirmation',
              modalProps: {
                onCancel: () => {
                  this.props.saveConfiguration(this.props.configuration).then(() => {
                    this.props.showNotification(I10n.get('saved_configuration.configuration_saved'),'success', null);
                  }).catch(() => { });
                  this.props.closeModal();
                },
                onSubmit: () => {
                  this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply).then(() => {
                  }).catch(() => { });
                  this.props.closeModal();
                },
                title: I10n.get('modal.skip_power_supply_selection.title'),
                text: I10n.get('modal.skip_power_supply_selection.body'),
                cancelText: I10n.get('app.action.no'),
                submitText: I10n.get('app.action.yes'),
              }
            });
          } else {
            this.props.saveConfiguration(this.props.configuration).then(() => {
              this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
            }).catch(() => { });
          }
        }
       }, active: configurationHasHeadModule, done: isConfigurationSaved},
    ];
  }

  toggleMobileFilter = (status) => {
    this.updateStateIfMounted({ mobileFilterOpened: status });
  }

  renderMobileQuestionButton = () => {
    return  <ContentWrapperMobile id='ContentWrapper-Mobile' fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>

    {(this.props.questions.isLoading || this.props.questions.aggregatedQuestions.length) > 0 &&
  <SearchBarTestWrapperMobile id='SearchBarTestWrapper-Mobile'>
    <FilterHeadWrapperMobile id='FilterHeadWrapper-Mobile' isHidden={this.state.isFilterOpen} onClick={() => this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }))}>
      <FilterHead
      isLoading={this.props.isLoading}
      toggleFilter={this.toggleFilter}
      numberQuestionsAnswered={this.numberQuestionsAnswered}
      />
    </FilterHeadWrapperMobile>
  <SearchBarWrapperMobile id='SearchBarWrapper-Mobile'>
      <SearchBarMobile id='SearchBar-Mobile'>
        <SearchBarIcon id='SearchBarIcon-Mobile'>
        <MsxIcons name="search" size="small"></MsxIcons>
        </SearchBarIcon>
        <SearchReferenceInput
          id="head-device-selector-screen-search-input"
          type="search"
          placeholder={I10n.get(`modal.add_module.search.placeholder`)}
          value={this.state.search}
          onChange={this.handleSearchChange}
          style={{ paddingLeft: '50px' }}
          color='#E6E6E6'
        ></SearchReferenceInput>
      </SearchBarMobile>
    </SearchBarWrapperMobile>
    </SearchBarTestWrapperMobile>}
  </ContentWrapperMobile>
  }

  clearCBRCategory = (category) => {
    this.props.openModal({
      modalType: 'confirmation',
      modalProps: {
        onCancel: () => { this.props.closeModal(); },
        onSubmit: () => {
          const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
          if (newValue.selectedItems[category]) {
            newValue.selectedItems[category] = {};
          }
          this.props.setCallByRangeSelectedItems(newValue);
          this.props.setHeadQuestionsWithAnswers({});
          this.getHeadModules({}, true);
          logDeleteCBRFilterEvent(this.props.configuration?.id, stepsConfig.head_device_selector_screen, category);
          this.props.closeModal();
        },
        title: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.title'),
        text: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.body'),
        cancelText: I10n.get('app.action.cancel'),
        submitText: I10n.get('app.action.apply'),
      }
    });
  }


  handleTotalQuestionsAnsweredChange = (total) => {
    this.setState({ totalQuestionsAnswered: total });
  };


  renderScreenContent = () => {
    return (
      <>
        <PageContent direction="col" fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          <MainContainer id='HeadDevice 1'>
            <ContentWrapper id='HeadDevice 2' fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
              {(this.props.questions.isLoading || this.props.questions.aggregatedQuestions.length) > 0 &&
                <SearchBarTestWrapper id='HeadDevice 3'>
                  <Test id='head-device-selector-screen-Test'>
                    <FilterHeadWrapper id='HaedDeviceFitlerHeadWrapper' isHidden={this.state.isFilterOpen} onClick={() => this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }))}>
                      <FilterHead
                        isLoading={this.props.isLoading}
                        toggleFilter={this.toggleFilter}
                        numberQuestionsAnswered={this.numberQuestionsAnswered}
                      />
                    </FilterHeadWrapper>
                  </Test>
                  <SearchBarWrapper id='HeadDevice 4'>
                    <SearchHeader id='HeadDevice 5'>
                      <SearchBar id='HeadDevice 6'>
                        <SearchBarIcon>
                          <MsxIcons name="search" size="small"></MsxIcons>
                        </SearchBarIcon>
                        <SearchReferenceInput
                          id="head-device-selector-screen-search-input"
                          type="search"
                          placeholder={I10n.get(`${this.baseI10nKey}.search.placeholder`)}
                          value={this.state.search}
                          onChange={this.handleSearchChange}
                          style={{ paddingLeft: '50px' }}
                          color='#E6E6E6'
                        ></SearchReferenceInput>
                      </SearchBar>
                    </SearchHeader>
                  </SearchBarWrapper>
                </SearchBarTestWrapper>
              }
            </ContentWrapper>
            <DeviceSectionWrapper id='HeadDevice 7'>
              <FilterContentWrapper id = 'FilterContentWrapper-headDeviceSelectorScreen'
                isFilterOpen={this.state.isFilterOpen}
              >
                <FilterContent
                  isFilterOpen={this.state.isFilterOpen}
                  aggregatedQuestions={this.props.questions.aggregatedQuestions}
                  renderCategories={this.props.renderCategories}
                  haveQuestionsAnswered={this.props.haveQuestionsAnswered}
                  resetQuestionAnswers={this.resetQuestionAnswers}
                  onAnswerChanged={this.onAnswerChanged}
                  questionsWithAnswers={this.props.configuration.headQuestionsWithAnswers}
                  questionMap={this.getQuestionMap()}
                  remainingOptions={this.state.remainingOptions}
                  sharedOptions={this.state.sharedOptions}
                  resultsLoading={this.props.headModules.isLoading}
                  mobileFilterOpened={this.state.mobileFilterOpened}
                  toggleMobileFilter={this.toggleMobileFilter}
                  baseOptions={this.props.configuration?.baseOptions}
                  toggleFilter={() => this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }))}
                >
                </FilterContent>
              </FilterContentWrapper >
              <DeviceSection id='HeadDevice 8' isFilterOpen={this.state.isFilterOpen}>
                <MobileQuestionManagement>
                  {!this.props.questions.isLoading && this.props.questions?.aggregatedQuestions?.length > 0 && this.renderMobileQuestionButton()}
                </MobileQuestionManagement>
                <DeviceSectionHeadText>{I10n.get(`${this.baseI10nKey}.suggest`)}</DeviceSectionHeadText>
                <DeviceSectionContent ref={c => {this.deviceSectionElement = c;}}>
                  {(this.props.headModules.isLoading ||
                    this.props.configurationSaver.isSaving ||
                    this.props.questions.isLoading) &&
                    <LoadingMask>
                      <LoadingSpinner id="head-device-selector-ranges-spinner"></LoadingSpinner>
                    </LoadingMask>
                  }
                  <Scrollbars ref={c => { this.scrollComponent = c }}>
                    {this.renderRanges()}
                  </Scrollbars>
                </DeviceSectionContent>
              </DeviceSection>
            </DeviceSectionWrapper>
          </MainContainer>
          <Notification>
          </Notification>
          <FillSpace></FillSpace>
          {(window.self === window.parent || appConfiguration.showDistributorSurvey) && !this.props.survey.isLoading &&
            <Survey
              appTitle={I10n.get('app.title.' + this.props.configuration.starterType)}
              surveyData={this.props.survey?.surveyData}
              getLabel={(key) => I10n.get(key)}
              preselectionnedAnswers={{ 'embedded_survey.choose_a_category': 'embedded_survey.step.plc_selection' }}
              onOpen={() => {
                logSurveyOpenEvent(surveyEventTypes.intermediate_open, this.props.configuration.id, stepsConfig.head_device_selector_screen);
              }}
              onSubmit={(surveyAnswers) => {
                logSurveySubmitEvent(surveyEventTypes.intermediate_sent, this.props.configuration.id, stepsConfig.head_device_selector_screen, surveyAnswers);
              }}
              fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
              color={appConfiguration.globalStyles.secondaryColor}
            ></Survey>
          }
        </PageContent>
      </>
    );
  }



  renderWithEventualScrollBar = (screenContent) => {
    return ((this.state.isDesktop && !this.props.applicationParameters.fullScreenEnabled) ? <>{screenContent}</> :
      <FullScreenScrollbarWrapper>
        {screenContent}
      </FullScreenScrollbarWrapper>
    );
  }

  render = () => {
    const isConfigurationSaved = (configurationStatuses.finished === this.props.configuration.status) || (this.props.configuration.id == null);
    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.title.' + this.props.configuration.starterType)}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={() => { this.confirmationBeforeCancel(!isConfigurationSaved, this.props.cancel); }}
          applicationParameters={this.props.applicationParameters}
          steps={getStepperLabels(this.props.configuration.starterType)}
          activeStep={stepsConfig.head_device_selector_screen}
          stepperActions={this.getStepperActions()}
          selectedCriteria={this.props.callByRangeReducer?.selectedItems || {}}
          clearCategory={this.clearCBRCategory}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          mySchneiderLink={buildMySchneiderUrlWithCBR(this.props.callByRangeReducer?.selectedItems, this.state.shouldHandleDefaultSearchParameters, false)}
          isSoftwareLicenseConfiguration={false}
        ></ApplicationFullHeader>
        {this.renderWithEventualScrollBar(this.renderScreenContent())}
        {this.renderNavigationButtonSection()}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    createConfigurationWithModule: (configuration, filters) => dispatch(createConfigurationWithModule(configuration, filters)),
    getHeadModules: (starterType, criteria) => dispatch(getHeadModules(starterType, criteria)),
    getAggregatedQuestions: (headModuleType) => dispatch(getQuestions(headModuleType)),
    setBaseOptions: (baseOptions) => dispatch(setBaseOptions(baseOptions)),
    setHeadQuestionsWithAnswers: (questionsWithAnswers) => dispatch(setHeadQuestionsWithAnswers(questionsWithAnswers)),
    continue: () => dispatch(setActiveStep(stepsConfig.configuration_editor_screen)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    cancel: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    setConfigurationHeadModule: (...args) => dispatch(setConfigurationHeadModule(...args)),
    replaceModule: (...args) => dispatch(replaceModule(...args)),
    removeHandleDefaultSearchParameters: () => dispatch(removeHandleDefaultSearchParameters()),
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    getSurvey: () => dispatch(getSurvey(surveyTypes.intermediate)),
    setCallByRangeSelectedItems: (items) => dispatch(setCBRSelectedItems(items)),
    updateShowButtonAnimations: () => dispatch(updateShowButtonAnimations({survey: false})),
    preSaveConfiguration: (configuration, step) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finalized, step)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeadDeviceSelectorScreen);
